import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "check2",
  "use": "check2-usage",
  "viewBox": "0 0 500 500",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 500 500\" id=\"check2\">\n  <polygon fill=\"currentColor\" points=\"360.944 0 147.731 256.168 39.054 125.595 0 172.516 147.731 350 400 46.921\" transform=\"translate(52 71)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol